import { Box, Typography } from '@mui/material';
import { WD } from '../../../warningDashboard/warningTheme';
import { FIGURE, LEVEL_TONE, LOAD_LEVELS } from '../utils/constants';
import { fmtHours } from '../utils/hours';
import PersonAvatar from './PersonAvatar';

/** The names behind a calendar tag, shown on hover: "Overloaded (3)" over a list of faces with their hours. */
export default function NamesTip({ level, entries }) {
  return (
    <Box sx={{ py: 0.5 }}>
      <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: LEVEL_TONE[level].text }}>
        {LOAD_LEVELS[level].label} ({entries.length})
      </Typography>
      <Box sx={{ mt: 0.75, display: 'grid', gap: 0.75 }}>
        {entries.map(({ person, hours, pct }) => (
          <Box key={person.id} display="flex" alignItems="center" gap={1}>
            <PersonAvatar person={person} size={20} />
            <Typography noWrap sx={{ flex: 1, minWidth: 0, fontSize: 12, color: WD.ink }}>{person.name}</Typography>
            <Typography sx={{ fontSize: 11, color: WD.inkMuted, ...FIGURE }}>
              {fmtHours(hours)} · {Math.round(pct)}%
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
